import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Route, Redirect, Switch } from 'react-router-dom';
import { ConfigProvider, Layout } from 'antd';

import Sidebar from './Sidebar';
import Header from './Header';

import Releases from '../../releases';
import Catalog from '../../catalog';
import Model from '../../model';
import News from '../../news';
import Featured from '../../featured';
import Editors from "../../editors";
import Settings from '../../settings';
import Keywords from "../../keywords";
import Raffles from '../../raffles';
import Posts from "../../posts"
import Tags from "../../tags"
import Giveaway from '../../giveaway';

class MainLayout extends Component {
  contentRef = React.createRef();

  render() {
    const { role } = this.props.user;

    return (
      <Layout className="main-layout">
        <Sidebar userRole={role} />
        <Layout>
          <Header />
          <Layout.Content>
            <ConfigProvider getPopupContainer={() => this.contentRef.current || document.body}>
              <div ref={this.contentRef} className="main-layout__content-inner">
                <Switch>
                  <Redirect exact from="/" to="/releases" />

                  <Route path="/releases" component={Releases} />
                  <Route path="/posts" component={Posts} />
                  <Route path="/catalog" component={Catalog} />
                  <Route path="/model" component={Model} />
                  <Route path="/news" component={News} />
                  <Route path="/featured" component={Featured} />
                  <Route path="/keywords" component={Keywords} />
                  <Route path="/raffles" component={Raffles} />
                  <Route path="/giveaway" component={Giveaway} />
                  <Route path="/tags" component={Tags} />

                  {role === 'admin' && <Route path="/editors" component={Editors} />}

                  <Route path="/settings" component={Settings} />
                </Switch>
              </div>
            </ConfigProvider>
          </Layout.Content>
        </Layout>
      </Layout>
    );
  }
}

export default connect(({ auth: user }) => ({ user }), null)(MainLayout);
